import styled from 'styled-components'

import { SubmissionSent } from '../SubmissionLink/SubmissionLink'
import { PeopleCard } from 'features/LeadGen/RetailerProfile/components/PeopleCard/PeopleCard'

type PeopleEmptyProps = {
  isRetailer?: boolean
  contactUrl?: string
  submissionSent?: SubmissionSent
}

const StyledPeopleCard = styled(PeopleCard)`
  display: flex;
  margin-top: 24px;
`

const PeopleEmpty = ({
  isRetailer,
  contactUrl,
  submissionSent,
}: PeopleEmptyProps) => {
  const canSendSubmission = contactUrl && !submissionSent

  return (
    <StyledPeopleCard
      name="Administrator"
      contactUrl={canSendSubmission ? contactUrl : undefined}
      submissionSent={submissionSent}
      isRetailer={isRetailer || false}
      iconName="storefront"
    />
  )
}

export default PeopleEmpty
